import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useId } from 'react';
import { Input } from '../../primitives/Input.js';
import { describedBy, FieldHost } from '../FieldHost.js';
function asString(v) {
    return typeof v === 'string' ? v : '';
}
export function DateField(props) {
    const { item, value, errors, disabled, onChange } = props;
    const id = useId();
    const current = asString(value);
    return (_jsx(FieldHost, { item: item, errors: errors, controlId: id, children: (ctx) => (_jsx(Input, { id: id, type: "date", value: current, disabled: disabled === true, required: item.required === true, "aria-invalid": ctx.hasError || undefined, "aria-describedby": describedBy(ctx), onChange: (e) => {
                const raw = e.currentTarget.value;
                onChange(raw === '' ? undefined : raw);
            } })) }));
}
//# sourceMappingURL=DateField.js.map